<template>
    <LayoutDefault :adminOverride="adminOverride" :adminCompany="adminCompany" :user="user">
        <template #default>
            <div class="flex flex-col justify-between">
                <div
                    class="m-auto pt-16 lg:pt-0 w-full lg:mt-16 px-6 lg:px-0"
                    :class="{
                        'lg:w-[792px]': !width && !adminOverride,
                        'lg:w-[872px]': width && !adminOverride,
                        'lg:w-full': adminOverride,
                    }"
                >
                    <h3 class="w-full text-center text-32 lg:text-44 font-bold font-hero capitalize"><slot name="title" /></h3>
                    <p class="w-full text-center text-17 lg:text-24 mt-3 font-sub"><slot name="sub" /></p>
                    <p class="w-full text-center mt-2 text-grey-900 text-15 mb-12"><slot name="text" /></p>

                    <slot name="above-live" />

                    <div class="bg-grey-500 h-px w-full" />

                    <div class="mt-14 w-full lg:w-[584px] m-auto lg:pb-[128px]">
                        <slot />
                    </div>
                </div>
            </div>
        </template>

        <!-- <template v-if="adminOverride" #default>
            <div class="flex flex-col justify-between">
                <div class="m-auto pt-0 lg:pt-0 w-full lg:mt-0 px-6 lg:px-12">
                    <slot />
                </div>
            </div>
        </template> -->

        <template v-if="!adminOverride" #footer>
            <div class="w-full bg-grey py-10 lg:px-[196px] px-6 lg:grid lg:grid-cols-3 text-13 text-grey-900 mt-22 lg:mt-0">
                <p class="w-full text-center lg:text-left lg:text-14">©{{ $moment().format('YYYY') }} Zapocom Limited. All rights reserved.</p>

                <p class="w-full flex justify-center mt-2 lg:mt-0">
                    <a href="https://www.zapo.com/terms-and-conditions" class="link-grey-900" target="_blank">Terms</a>
                    <span class="block mx-4">/</span>
                    <a class="link-grey-900" href="https://www.zapo.com/privacy-policy" target="_blank">Privacy</a>
                </p>

                <a
                    href="https://uk.trustpilot.com/review/getwork.co.uk?utm_medium=Trustbox&utm_source=app.zapo.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex items-center justify-center lg:justify-end gap-3 mt-4 lg:mt-0 h-6"
                >
                    <img class="h-[20px] mt-[-2px]" src="https://emailsignature.trustpilot.com/brand/s/4/logo.png" />
                    <img class="h-6" src="https://emailsignature.trustpilot.com/newsletter/en-GB/2/5dde7b1cd5594d0001d706fa/stars.png" />
                </a>
            </div>
        </template>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from '~/layouts/default.vue'
import MasterLayoutMixin from '~/mixins/master-mixin.js'
// import Intercom from '~/mixins/intercom.js';

export default {
    props: {
        adminOverride: { type: Boolean, default: false },
        adminCompany: { type: Object, default: null },
        user: { type: Object, default: null },
    },

    data() {
        return {
            width: false,
        }
    },

    components: {
        LayoutDefault,
    },
}
</script>
